<template>
    <div>
        <RequestList
            v-bind:documentTableName="$t(status)"
            v-bind:documentTableContent="requestTableDataContent"
            v-bind:documentTableLoading="requestLoading"
            v-on:handleRowClicked="handleRowClicked"
            :tableOptionsToExport="tableOptionsToExport"
        ></RequestList>
        <v-dialog v-model="showRequestForView">
            <v-card>
                <RequestViewer v-bind:request-id="requestIdForView"></RequestViewer>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="showRequestForView = false">{{$t('Закрыть')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import RequestList from '../components/RequestList';
import RequestViewer from '../views/RequestViewer';
import { mapGetters, mapState, mapActions } from 'vuex';
import { debounce } from '../utility/routines';

export default {
    components: { RequestList, RequestViewer },
    data() {
        return {
            debouncedGetList: null,
            loading: false,
            requestIdForView: null,
            showRequestForView: false,
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 10, // -1 for All",
                sortBy: null,
                totalItems: 0
            },
            requestType: [],
            roesName: [],
            dateFrom: null,
            dateTo: null
        };
    },
    watch: {
        userBaseFolderId: function () {
            this.getRequestListLocal();
        },
        pagination: function () {
            this.getRequestListLocal();
        },
        requestType() {
            this.pagination.page = 1;
            if (!this.debouncedGetList) return;
            this.debouncedGetList(1300);
        },
        roesName() {
            this.pagination.page = 1;
            if (!this.debouncedGetList) return;
            this.debouncedGetList(1300);
        },
        dateFrom() {
            this.pagination.page = 1;
            this.getRequestListLocal();
        },
        dateTo(value) {
            this.pagination.page = 1;
            this.getRequestListLocal();
        }
    },
    computed: {
        ...mapGetters('request', ['requestTableDataContent']),
        ...mapState('user', ['userBaseFolderId', 'userData']),
        ...mapState('request', ['requestList', 'requestLoading']),
        tableOptionsToExport() {
            let requestType = '';
            this.requestType.forEach(type => {
                requestType += `${type}|`;
            });
            requestType = requestType.substring(0, requestType.length - 1);
            requestType = `${requestType}`;

            let roesName = '';
            this.roesName.forEach(type => {
                roesName += `${type}|`;
            });
            roesName = roesName.substring(0, roesName.length - 1);
            roesName = `${roesName}`;

            return {
                folderId: this.userBaseFolderId,
                status: this.status,
                requestType: requestType,
                roesName: roesName,
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                page: 0,
                rowsPerPage: this.requestList.totalElements,
                sortBy: this.pagination.sortBy,
                descending: this.pagination.descending
            };
        }
    },
    methods: {
        ...mapActions('request', ['getRequestList', 'getDocumentPermissions']),
        async handleRowClicked(item) {
            let docPermissions = await this.getDocumentPermissions(item.id);
            if (docPermissions.execute_access) {
                this.handleExecuteProcess(item);
            } else if (docPermissions.view_access) {
                this.handeViewRequest(item.id);
            }
        },
        handleExecuteProcess(item) {
            this.$router.push({ name: 'processform', params: { processId: item.requestProcessId, requestId: item.id, status: this.status } });
        },
        handeViewRequest(itemId) {
            this.requestIdForView = itemId;
            this.showRequestForView = true;
        },
        async getRequestListLocal() {
            if (this.userBaseFolderId) {
                let requestType = '';
                this.requestType.forEach(type => {
                    requestType += `${type}|`;
                });
                requestType = requestType.substring(0, requestType.length - 1);
                requestType = `${requestType}`;

                let roesName = '';
                this.roesName.forEach(type => {
                    roesName += `${type}|`;
                });
                roesName = roesName.substring(0, roesName.length - 1);
                roesName = `${roesName}`;

                this.loading = true;
                await this.getRequestList({
                    folderId: this.userBaseFolderId,
                    status: this.status,
                    requestType: requestType,
                    roesName: roesName,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    p: this.pagination
                });
                this.loading = false;
                this.pagination.totalItems = this.requestList.totalElements;
            }
        }
    },
    mounted() {
        this.debouncedGetList = debounce(this.getRequestListLocal);
    },
    beforeDestroy() {
        this.debouncedGetList = null;
    }
};
</script>


